module.exports = function ({
  me,
  customFlagLabel
}) {
  return [{
    label: `By Client and ${me.terms?.Matter}`,
    toggle: false,
    showReportList: me.permissions?.reports?.view || me.permissions?.reports?.billable || me.permissions?.reports?.revenue,
    options: [{
      label: "Billable",
      reportType: "client-matter-billables",
      tooltipData: "Summarizes billable hours, fixed fees, and expenses by client. Use the Show Billed filter to see billed or unbilled.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.billable
    }, {
      label: "Productivity",
      reportType: "client-matter-productivity",
      tooltipData: "Combines billed and ready to bill hours and expenses, by client. Shows written-down hours and amounts.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.billable
    }, {
      label: "Ready to Bill / WIP",
      reportType: "ready-to-bill",
      tooltipData: "Compares ready to bill hours, fixed fees, and expenses against client A/R and trust balances.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.billable
    }, {
      label: "WIP, Billed, Collected",
      reportType: "client-wip-billed-collected",
      tooltipData: "Overviews services and expenses from all unbilled, billed, and collected states, sorted by client.",
      dateRangeOptions: true,
      generic: true,
      showReport: me.permissions?.reports?.revenue
    }, {
      label: "Revenue",
      reportType: "client-matter-revenue",
      tooltipData: "Summarizes billed totals compared to all recorded payments, sorted by client. Click a client’s name to view payment details.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.revenue
    }]
  }, {
    label: "By User",
    toggle: false,
    showReportList: me.permissions?.reports?.view || me.permissions?.reports?.billable || me.permissions?.reports?.revenueAttorney || me.permissions?.reports?.revenue,
    options: [{
      label: "Billable",
      reportType: "attorney-billable",
      tooltipData: "Summarizes billable hours, fixed fees, expenses, and contingency by user.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.billable
    }, {
      label: "Productivity",
      reportType: "timekeeper-productivity",
      tooltipData: "Combines billed and ready to bill hours and expenses, by user. Shows written-down hours and amounts.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.billable
    }, {
      label: `Compensation (Revenue by ${me.terms?.Lead})`,
      reportType: "attorney-revenue",
      tooltipData: "Assigns collected payments into user compensation based on contributions and firm, origination, and responsible allocation percentages",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.revenueAttorney
    }, {
      label: "Collected by Originating",
      reportType: "origination",
      tooltipData: "Sorts firm revenue by originator. Shows origination amounts and percentages.",
      dateRangeOptions: true,
      generic: true,
      showReport: me.permissions?.reports?.revenueAttorney
    }, {
      label: "Billed by Originating",
      reportType: "originating-attorney-billed",
      tooltipData: "Totals all billed line items and credits by their originating user(s)",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.revenueAttorney
    }, {
      label: "WIP, Billed, Collected",
      reportType: "user-wip-billed-collected",
      tooltipData: "Overviews services and expenses from all unbilled, billed, and collected states, sorted by user.",
      dateRangeOptions: true,
      generic: true,
      showReport: me.permissions?.reports?.revenue
    }, {
      label: "WIP Detail",
      reportType: "wip-detail",
      tooltipData: "Lists ready to bill time entries and firm expenses, with their descriptions, sorted by user.",
      dateRangeOptions: false,
      generic: true,
      showReport: me.permissions?.reports?.billable
    }]
  }, {
    label: "By Responsible",
    toggle: false,
    showReportList: me.permissions?.reports?.view || me.permissions?.reports?.billable || me.permissions?.reports?.revenue,
    options: [{
      label: "Billable",
      reportType: "responsible-billable",
      tooltipData: "Totals the billable hours, fixed fees, and expenses for each user marked as Responsible.",
      dateRangeOptions: true,
      generic: true,
      showReport: me.permissions?.reports?.billable
    }, {
      label: "WIP, Billed, Collected",
      reportType: "responsible-wip-billed-collected",
      tooltipData: "Overviews services and expenses from all ready to bill, billed, and collected states from each Responsible user.",
      dateRangeOptions: true,
      generic: true,
      showReport: me.permissions?.reports?.revenue
    }, {
      label: "Collected",
      reportType: "responsible-collected",
      tooltipData: "Totals the services and expenses from collected payments, sorted by Responsible user.",
      dateRangeOptions: true,
      generic: true,
      showReport: me.permissions?.reports?.revenue
    }]
  }, {
    label: "By Practice Area",
    toggle: false,
    showReportList: me.company?.usesMatterTags && (me.permissions?.reports?.view || me.permissions?.reports?.billable || me.permissions?.reports?.revenue),
    options: [{
      label: "Billable",
      reportType: "practice-area-billables",
      tooltipData: "Totals the billable and non-billable hours, fixed fees, and expenses for each practice area.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.billable
    }, {
      label: "WIP, Billed, Collected",
      reportType: "practice-area-wip-billed-collected",
      tooltipData: "Overviews services and expenses from all ready to bill, billed, and collected states, sorted by practice area.",
      dateRangeOptions: true,
      generic: true,
      showReport: me.permissions?.reports?.revenue
    }, {
      label: "Revenue",
      reportType: "practice-area-revenue",
      tooltipData: "Summarizes billed totals compared to all recorded payments, sorted by practice area.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.revenue
    }]
  }, {
    label: "Accounting",
    toggle: false,
    showReportList: me.permissions?.reports?.view,
    options: [{
      label: "Receivables",
      reportType: "receivables",
      tooltipData: "Lists all clients’ balances and the aging of overdue invoices based on 30 day periods.",
      dateRangeOptions: false,
      generic: false,
      showReport: me.permissions?.reports?.billable
    }, {
      label: "Trust Report",
      reportType: "trust",
      tooltipData: "Compares client trust balances against their WIP, listing how much of their WIP is covered by trust.",
      dateRangeOptions: false,
      generic: false,
      showReport: me.permissions?.trust?.view || me.company?.settings?.trustEnabled
    }, {
      label: "Deposit",
      reportType: "deposit-lists",
      tooltipData: "Lists all deposits made to trust and operating accounts through LeanLaw.",
      dateRangeOptions: false,
      generic: true,
      showReport: me.permissions?.trust?.view && me.permissions?.trust?.deposit && me.company?.settings?.trustEnabled
    }]
  }, {
    label: "Other Client Reports",
    toggle: false,
    showReportList: me.permissions?.reports?.view,
    options: [{
      label: "Contingency Statement",
      reportType: "contingency",
      tooltipData: "Overviews fees, hours, expenses, and trust connected to all contingency clients.",
      dateRangeOptions: true,
      generic: false,
      showReport: true
    }, {
      label: "Contingency Expense Period",
      reportType: "contingency-expense",
      tooltipData: "Totals the expenses spent on contingency cases over periods you set.",
      dateRangeOptions: true,
      generic: false,
      showReport: true
    }, {
      label: "Fixed Fee Profitability",
      reportType: "fixed-fee-profitability",
      tooltipData: "Compares fixed fee hours and amounts against billable hours and amounts, when both apply.",
      dateRangeOptions: true,
      generic: false,
      showReport: me.permissions?.reports?.billable
    }, {
      label: "Client Contact",
      reportType: "client-contact",
      tooltipData: "Gathers all clients’ contact information into one place for printing and exporting.",
      dateRangeOptions: false,
      generic: false,
      showReport: true
    }]
  }, {
    label: "Matter Management",
    toggle: false,
    showReportList: me.permissions?.reports?.view,
    options: [{
      label: `${me.terms?.Matter} Activity`,
      reportType: "matter-activity",
      tooltipData: "Lists all works for your clients based on when they were last active, opened, or archived.",
      dateRangeOptions: false,
      generic: false,
      showReport: true
    }, {
      label: `${me.terms?.Matter} Rates`,
      reportType: "matter-rates",
      tooltipData: "Lists all users' rates for all clients' works, as well as who’s responsible and originating.",
      dateRangeOptions: false,
      generic: false,
      showReport: me.permissions?.matters?.rates
    }]
  }, {
    label: "Other",
    toggle: false,
    showReportList: me.permissions?.reports?.view,
    options: [{
      label: "Period Reports",
      reportType: "period-reports",
      tooltipData: "A highly customizable report for looking up details within a defined period.",
      dateRangeOptions: false,
      generic: false,
      showReport: true
    }, {
      label: `${customFlagLabel} report`,
      reportType: "client-matter-customflag",
      tooltipData: "Compares billed hours where the custom checkbox was selected against those that weren’t.",
      dateRangeOptions: true,
      generic: false,
      showReport: customFlagLabel || me.permissions?.reports?.billable
    }, {
      label: `${me.company?.settings?.labels?.custom1}`,
      reportType: "custom",
      tooltipData: "",
      dateRangeOptions: true,
      generic: false,
      showReport: me.features?.customReport && me.company?.settings?.labels && me.company?.settings?.labels?.custom1
    }]
  }, {
    label: "My Reports",
    toggle: false,
    showReportList: me.permissions?.reports?.myrevenue,
    options: [{
      label: "My Compensation (My Revenue)",
      reportType: "attorney-my-revenue",
      tooltipData: "Anticipates your compensation from collected payments based on contributions and firm, origination, and other allocation settings.",
      dateRangeOptions: true,
      generic: false,
      showReport: true
    }, {
      label: "My WIP, Billed, Collected",
      reportType: "my-wip-billed-collected",
      tooltipData: "Combination report of unbilled items, billed and collected totals for a time period",
      dateRangeOptions: true,
      generic: true,
      showReport: true
    }, {
      label: "My Productivity",
      reportType: "my-productivity",
      tooltipData: "Summary of your billable hours and associated amounts.",
      dateRangeOptions: true,
      generic: false,
      showReport: true
    }, {
      label: "My Receivables",
      reportType: "my-receivables",
      tooltipData: "Lists all clients’ balances and the aging of overdue invoices based on 30 day periods.",
      dateRangeOptions: false,
      generic: false,
      showReport: me.features?.myReceivablesReport
    }, {
      label: "My Origination Info",
      reportType: "my-origination-info",
      tooltipData: "Shows all matters that you originated including the origination percentages and step-down settings.",
      dateRangeOptions: false,
      generic: true,
      showReport: me.features?.myOrigination
    }, {
      label: "My WIP Detail",
      reportType: "my-wip-detail",
      tooltipData: "Lists all ready to bill time entries, fixed fees, and expenses assigned to you.",
      dateRangeOptions: false,
      generic: true,
      showReport: true
    }]
  }];
};